<template lang="pug">
  .top-0.left-0.w-full.pointer-events-none.flex.justify-center(v-if="site && site.logo_file", :style="{fontSize: site.logo_height / 10 + 'rem' }")
    .pointer-events-auto.pt-12.flex.items-center.cursor-pointer(@click="$emit('click')")
      //- logo
      img.block.h-08em.sm-h-em(:src="cloudinary(site.logo_file)", alt="OTTOLINGER", :style="{filter: !black ? 'invert(100%)' : ''}")
</template>

<script>
import { mapState } from 'vuex'
import { cloudinaryThumbSrc as cloudinary } from '@/utils'
export default {
  props: ['black'],
  data () {
    return {
      cloudinary
    }
  },
  computed: {
    ...mapState(['site']),
    style () {
      return {
        // logo height size by font-size
        fontSize: (this.site && this.site.logo_height / 10 + 'rem') || '2rem'
      }
    }
  }
}
</script>

<style>
</style>
